<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import KNavbar from '@/components/navbar/KNavbar.vue';
import KSidebar from '@/components/sidebar/KSidebar.vue';
import EulaDialog from '@/pages/eula/EulaDialog.vue';

import type { LayoutSettings } from '.';
import DefaultLayoutFooter from './DefaultLayoutFooter.vue';
import DefaultLayoutHeader from './DefaultLayoutHeader.vue';

const route = useRoute();

const wrapContentWithContainerClass = computed(() => {
  const settingProps = route.meta?.layout as LayoutSettings | undefined;

  return settingProps?.wrapContentWithContainerClass ?? true;
});

const sidebarIsOpen = ref(false);

watch(route, () => (sidebarIsOpen.value = false));
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <KNavbar :open="sidebarIsOpen" @close="sidebarIsOpen = false" />
    <div class="flex min-h-screen flex-col lg:ml-72">
      <DefaultLayoutHeader @openSidebar="sidebarIsOpen = true" />
      <!-- Desktop sidebar nav rendered here for correct tab order -->
      <div
        class="hidden lg:fixed lg:bottom-0 lg:left-0 lg:top-16 lg:z-50 lg:flex lg:w-72 lg:flex-col"
      >
        <KSidebar />
      </div>
      <main
        id="main-content"
        class="mx-4 flex-grow focus-visible:outline-2 focus-visible:outline-blue-400 sm:mx-6"
        tabindex="-1"
      >
        <slot name="mainContainer">
          <div
            :class="{
              'container mx-auto': wrapContentWithContainerClass,
            }"
          >
            <!-- Content will be placed here -->
            <slot></slot>
            <EulaDialog />
          </div>
        </slot>
      </main>
      <DefaultLayoutFooter />
    </div>
  </div>
</template>
